import type { Messages } from '../i18n';

const BUBBLE_ICON = `<svg class="bf-icon-bubble" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`;

const CLOSE_ICON = `<svg class="bf-icon-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

export interface Launcher {
  setActive(active: boolean): void;
  setDisabled(disabled: boolean): void;
  destroy(): void;
}

export function createLauncher(opts: {
  root: ShadowRoot;
  messages: Messages;
  onToggle(): void;
}): Launcher {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'bf-launcher';
  button.setAttribute('aria-label', opts.messages.launcherLabel);
  button.title = opts.messages.launcherLabel;
  button.innerHTML = BUBBLE_ICON + CLOSE_ICON;
  button.addEventListener('click', opts.onToggle);
  opts.root.appendChild(button);

  return {
    setActive(active: boolean) {
      button.classList.toggle('bf-active', active);
      const label = active ? opts.messages.cancelPicking : opts.messages.launcherLabel;
      button.setAttribute('aria-label', label);
      button.title = label;
    },
    setDisabled(disabled: boolean) {
      button.disabled = disabled;
      button.classList.toggle('bf-disabled', disabled);
    },
    destroy() {
      button.remove();
    },
  };
}
